import React from 'react';
import { Play, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../layout/Header';
import Footer from '../layout/Footer';

const videoProducts = [
  {
    id: 1,
    title: "100,000 Videos Bundle",
    description: "A massive library of ready-to-use videos you can post, edit, or resell to save time and stay consistent with content.",
    price: 30,
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/zdxH4PzT8wn8qZaK3qCE/media/6945efd58cae8f3420ffbef1.webp",
    tag: "Best Seller",
    videos: "100,000+"
  },
  {
    id: 2,
    title: "Nature Videos",
    description: "High-quality nature and travel clips perfect for calming content, backgrounds, reels, and aesthetic edits.",
    price: 30,
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/zdxH4PzT8wn8qZaK3qCE/media/6945f69c0fb2962c74694c8b.webp",
    tag: null,
    videos: "8,500+"
  },
  {
    id: 3,
    title: "Motivational & Luxury Videos",
    description: "Attention-grabbing visuals that pair perfectly with motivational quotes, ads, and high-end brand content.",
    price: 30,
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/zdxH4PzT8wn8qZaK3qCE/media/6945fb7d9a634feaad2b6389.jpg",
    tag: "Popular",
    videos: "12,000+"
  },
  {
    id: 4,
    title: "Exercise Video Bundle",
    description: "Workout, yoga, and fitness videos ideal for fitness pages, coaching content, or faceless niche accounts.",
    price: 30,
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/zdxH4PzT8wn8qZaK3qCE/media/6945f73666d57825b01ba69a.webp",
    tag: null,
    videos: "5,000+"
  },
  {
    id: 5,
    title: "Viral Video Hooks",
    description: "Proven short-form hooks designed to stop the scroll and boost watch time on Reels, TikTok, and Shorts.",
    price: 30,
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/zdxH4PzT8wn8qZaK3qCE/media/6945f87c0190aff79d006fbe.webp",
    tag: "High Converting",
    videos: "3,200+"
  },
  {
    id: 6,
    title: "Faceless Videos",
    description: "Ready-made videos you can post without showing your face—great for affiliate, quote, and niche pages.",
    price: 30,
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/zdxH4PzT8wn8qZaK3qCE/media/6945f8e4aca6abe936a23b69.png",
    tag: null,
    videos: "15,000+"
  },
  {
    id: 7,
    title: "Funny Cat & Dog Videos",
    description: "Highly shareable pet content built to drive engagement, laughs, and viral potential.",
    price: 30,
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/zdxH4PzT8wn8qZaK3qCE/media/6945f976aad36025d187f547.jpg",
    tag: "Viral",
    videos: "7,500+"
  },
  {
    id: 8,
    title: "Luxury Car Videos",
    description: "Premium automotive clips perfect for luxury pages, edits, and motivational-style content.",
    price: 30,
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/zdxH4PzT8wn8qZaK3qCE/media/6945f837aad36006f587e28f.webp",
    tag: null,
    videos: "4,800+"
  },
  {
    id: 9,
    title: "Motivational Speeches",
    description: "Editable motivational video templates designed to inspire audiences and drive engagement.",
    price: 30,
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/zdxH4PzT8wn8qZaK3qCE/media/6945fc28aad360f7f0881f5b.png",
    tag: null,
    videos: "2,500+"
  },
  {
    id: 10,
    title: "Viral Luxury & Motivational",
    description: "A mix of luxury visuals and motivational content built for high-performing reels and posts.",
    price: 30,
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/zdxH4PzT8wn8qZaK3qCE/media/6945fb2baad3603ba988114e.webp",
    tag: "Premium",
    videos: "10,000+"
  },
  {
    id: 11,
    title: "Satisfying Videos",
    description: "Relaxing, oddly satisfying clips that perform well for retention, looping, and viral engagement.",
    price: 30,
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/zdxH4PzT8wn8qZaK3qCE/media/6945f9a7106fdcbdf8124ce0.webp",
    tag: null,
    videos: "6,200+"
  },
  {
    id: 12,
    title: "Gaming Background Videos",
    description: "High-quality gaming visuals perfect for streams, backgrounds, edits, and content creators.",
    price: 30,
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/zdxH4PzT8wn8qZaK3qCE/media/694600448cae8fe27700c66e.webp",
    tag: null,
    videos: "3,800+"
  }
];

const ThemePagesPage = () => {
  const navigate = useNavigate();

  const handleSelectTheme = (product) => {
    // Store selected theme in localStorage
    localStorage.setItem('autopostr_selected_theme', JSON.stringify({
      id: product.id,
      title: product.title,
      price: product.price,
      timestamp: new Date().toISOString()
    }));
    // Redirect to pricing page
    navigate('/pricing');
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-sm font-medium mb-6">
            Video Content Library
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Premium Theme Pages
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">
              Automated For You
            </span>
          </h1>
          <p className="text-lg text-white/60 max-w-3xl mx-auto">
            We provide high-quality, ready-to-post video content and fully schedule it directly to your account, ensuring 10 posts per day for 30 consecutive days — guaranteed.
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="pb-24 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {videoProducts.map((product) => (
              <div
                key={product.id}
                className="group relative bg-[#111] rounded-2xl overflow-hidden border border-white/5 hover:border-white/10 transition-all duration-300"
                data-testid={`product-card-${product.id}`}
              >
                {/* Image */}
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                  
                  {/* Play Icon */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                      <Play size={20} className="text-white ml-1" fill="white" />
                    </div>
                  </div>

                  {/* Tag */}
                  {product.tag && (
                    <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-emerald-500/90 text-white text-xs font-medium">
                      {product.tag}
                    </span>
                  )}

                  {/* Video Count */}
                  <span className="absolute bottom-3 left-3 px-2.5 py-1 rounded-full bg-black/60 backdrop-blur-sm text-white/90 text-xs font-medium">
                    {product.videos} videos
                  </span>
                </div>

                {/* Content */}
                <div className="p-4">
                  <h3 className="text-white font-semibold text-sm mb-1.5 line-clamp-1">
                    {product.title}
                  </h3>
                  <p className="text-white/50 text-xs mb-4 line-clamp-2 leading-relaxed">
                    {product.description}
                  </p>

                  {/* Button */}
                  <div className="flex items-center justify-end">
                    <button
                      onClick={() => handleSelectTheme(product)}
                      className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-semibold bg-white text-black hover:bg-white/90 transition-all duration-200"
                      data-testid={`select-theme-${product.id}`}
                    >
                      Select
                      <ArrowRight size={14} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ThemePagesPage;
